import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Activity = styled.div`
  width: 800px;
  max-width: 90%;
  margin: 0 auto;
  padding-bottom: calc(10rem + env(safe-area-inset-bottom, 0px));

  h1 {
    margin: 2.25rem 0 2.5rem;
    font-size: 1.8rem;
    line-height: 1.15;
  }

  @media screen and (max-width: 600px) {
    max-width: calc(100% - 2rem);
    padding-bottom: calc(11rem + env(safe-area-inset-bottom, 0px));

    h1 {
      margin: 1.75rem 0 2.35rem;
      font-size: 1.9rem;
    }
  }
`;

export const Section = styled.section`
  margin-top: 2.6rem;

  &:first-of-type {
    margin-top: 0;
  }

  @media screen and (max-width: 600px) {
    margin-top: 2.35rem;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 1rem;
  color: #ffffff;
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.2;

  @media screen and (max-width: 600px) {
    margin-bottom: 0.85rem;
    font-size: 1.36rem;
  }
`;

export const StatRow = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: 1.08rem;
  font-weight: 400;
  line-height: 1.35;

  > span:last-child {
    flex-shrink: 0;
    text-align: right;
  }

  @media screen and (max-width: 600px) {
    align-items: flex-start;
    font-size: 1.06rem;
    gap: 0.75rem;
  }
`;

export const SettingsLink = styled(Link)`
  margin-top: 0.85rem;
  color: #ffffff;
  display: inline-flex;
  gap: 0.75rem;
  align-items: center;
  font-size: 0.9rem;
  line-height: 1.4;
`;

export const LabelWithInfo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;

  span {
    min-width: 0;
  }
`;

export const InfoButton = styled.button`
  width: 1.4rem;
  height: 1.4rem;
  border: none;
  padding: 0;
  border-radius: 50%;
  background: transparent;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const InfoBox = styled.div`
  margin-top: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.035);
  padding: 0.75rem 0.85rem;
  color: rgba(255, 255, 255, 0.78);

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.76);
    font-size: 0.86rem;
    line-height: 1.42;
  }
`;

export const InfoDismissButton = styled.button`
  margin-top: 0.65rem;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: transparent;
  color: #ffffff;
  padding: 0.3rem 0.7rem;
  font-size: 0.78rem;
  line-height: 1;
  cursor: pointer;
`;
